import logo from './logo.svg';
import './App.css';
import React from 'react';

class App extends React.Component {

  nadpisOnlineSkoleni = "";
  nadpisPrezencnychSkoleni = "";
  eTurboRoutre = "";
  eTurboRoutreUrl = "";
  eTurboSwitche = "";
  eTurboSwitcheUrl = "";
  na0 = "";
  na0Url = "";
  na1 = "";
  na1Url = "";
  na2 = "";
  na2Url = "";

  naplnTextyPodlaJazyka() {
    let nacitanePremium = document.getElementById("lit-cs-lang4r").innerHTML;
    if (String(nacitanePremium) == 'sk') {
      this.nadpisOnlineSkoleni = "Online školenia:";
      this.nadpisPrezencnychSkoleni = "U nás v labe: ";
      this.eTurboRoutre = "Štart do konfigurácie Cisco routrov. Online, v Slovenčine, dostupné ihneď.";
      this.eTurboSwitche = "Štart do konfigurácie Cisco switchov. Online, v Slovenčine, dostupné ihneď.";
      this.na0 = "Štart do štúdia sietí";
      this.na1 = "Rozumieť Cisco routrom, subnetom a vedieť ich nastaviť";
      this.na2 = "Rozumieť Cisco switchom a vedieť ich nakonfigurovať";
      this.na0Url = "/kurz/ccna/na0-administracia-lanwan-a-navrh-tcpip-sieti-zakladne-koncepty.html";
      this.na1Url = "/kurz/ccna/na1-smerovanie-tcpip-sietach-prakticka-konfiguracia-routra-cisco.html";
      this.na2Url = "/kurz/ccna/na2-prepinanie-v-sietach-a-konfiguracia-prepinacov-cisco.html";
    } else if (String(nacitanePremium) == 'cz') {
      this.nadpisOnlineSkoleni = "Online školení:";
      this.nadpisPrezencnychSkoleni = "U nás osobně:";
      this.eTurboRoutre = "Start do konfigurace Cisco routrů. Online, dostupné ihned.";
      this.eTurboSwitche = "Start do konfigurace Cisco switchů. Online, dostupné ihned.";
      this.na0 = "Start do studia sítí";
      this.na1 = "Chci rozumět Cisco routrem, subnetem a umět je nastavit";
      this.na2 = "Chci rozumět Cisco switchům a umět je nakonfigurovat";
      this.na0Url = "/cz/kurz/ccna/na0-administrace-lanwan-a-navrh-tcpip-siti-zakladni-koncepty.html";
      this.na1Url = "/cz/kurz/ccna/na1-smerovani-v-tcpip-sitich-prakticka-konfigurace-routeru-cisco.html";
      this.na2Url = "/cz/kurz/ccna/na2-prepinani-v-sitich-a-konfigurace-prepinacu-cisco.html";
    }
  }

  constructor(props) {
    super(props);
    this.naplnTextyPodlaJazyka();
  }

  render() {
    return (
      <div className="lit-cmp-blog-ads row rounded shadow m-3">
          <div className='col-lg-8'>
            <h2>{this.nadpisOnlineSkoleni}</h2>
            <div className='row'>
              <div className='col-lg-6'>
                <a href='https://www.like-it.sk/f/online-kurz-siete-ako-nakonfigurovat-cisco-router/'>
                  <img className='img-fulid rounded-circle lit-cmp-ba-velky-obrazok' src='/../style/loga_kurzov/online/routre/routre.png'/>
                </a>
                  <a href='https://www.like-it.sk/f/online-kurz-siete-ako-nakonfigurovat-cisco-router/'>
                <p>{this.eTurboRoutre}</p>
                </a>
              </div>
              <div className='col-lg-6'>
              <a href='https://www.like-it.sk/f/online-kurz-siete-ako-nakonfigurovat-cisco-switch/'>
                <img className='img-fulid rounded-circle lit-cmp-ba-velky-obrazok' src='/../style/loga_kurzov/online/swithe/swithe.png'/>
              </a>
              <a href='https://www.like-it.sk/f/online-kurz-siete-ako-nakonfigurovat-cisco-switch/'>
              <p>{this.eTurboSwitche}</p>
              </a>
              </div>
            </div>
          </div>
          <div className='col-lg-4'>
            <h2>{this.nadpisPrezencnychSkoleni}</h2>
            <div className='lit-cmp-ba-wrap-unset'>
              <div className='lit-cmp-ba-wrap-maly'>
              <a href={this.na0Url}>
                <img className='img-fulid rounded-circle lit-cmp-ba-maly-obrazok m-2' src='/../style/loga_kurzov/na0/na0.png'/>
              </a>
                <div className='lit-cmp-ba-wrap-text-maly'>
                <a href={this.na0Url}>
                  <p className='lit-cmp-ba-wrap-text-maly'>{this.na0}</p>
                </a>
                </div>
              </div>
              <div className='lit-cmp-ba-wrap-maly'>
              <a href={this.na1}>
                <img className='img-fulid rounded-circle lit-cmp-ba-maly-obrazok m-2' src='/../style/loga_kurzov/na1/na1.png'/>
              </a>
                <div className='lit-cmp-ba-wrap-text-maly'>
                <a href={this.na1Url}>
                  <p>{this.na1}</p>
                </a>
                </div>
              </div>
              <div className='lit-cmp-ba-wrap-maly'>
              <a href={this.na2}>
                <img className='img-fulid rounded-circle lit-cmp-ba-maly-obrazok m-2' src='/../style/loga_kurzov/na2/na2.png'/>
              </a>
                <div className='lit-cmp-ba-wrap-text-maly'>
                <a href={this.na2Url}>
                  <p>{this.na2}</p>
                </a>
                </div>
              </div>
            </div>
          </div>
        </div>
    );

    }
}

export default App;
